import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

/** One help key (and id-free page) users opened without finding a text. Mirrors HelpMissingDTO. */
export interface HelpMissing {
    key: string;
    path: string;
    hits: number;
    firstSeen: string;
    lastSeen: string;
}

export const HelpService = {
    /** SystemAdmin only: the vendor's to-write list of missing help texts. */
    listMissing: async (): Promise<HelpMissing[]> => {
        const response = await axios.get<HelpMissing[]>(ENDPOINTS.HELP.MISSING, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
